export var NotificationType;
(function (NotificationType) {
    NotificationType["UNKNOWN_NOTIFICATION_TYPE"] = "UNKNOWN_NOTIFICATION_TYPE";
    NotificationType["REGULAR"] = "REGULAR";
    NotificationType["ALERT_WARNING"] = "ALERT_WARNING";
    NotificationType["ALERT_INFO"] = "ALERT_INFO";
})(NotificationType || (NotificationType = {}));
export var Channel;
(function (Channel) {
    Channel["UNKNOWN_CHANNEL"] = "UNKNOWN_CHANNEL";
    Channel["WEB"] = "WEB";
    Channel["MOBILE"] = "MOBILE";
})(Channel || (Channel = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["UNSEEN"] = "UNSEEN";
    Status["SEEN_BUT_UNREAD"] = "SEEN_BUT_UNREAD";
    Status["READ"] = "READ";
    Status["RESOLVED"] = "RESOLVED";
    Status["DISMISSED"] = "DISMISSED";
})(Status || (Status = {}));
export var DeeplinkType;
(function (DeeplinkType) {
    DeeplinkType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    DeeplinkType["WEB_URL"] = "WEB_URL";
    DeeplinkType["MOBILE"] = "MOBILE";
    DeeplinkType["DASHBOARD_PAGE"] = "DASHBOARD_PAGE";
})(DeeplinkType || (DeeplinkType = {}));
export var IconType;
(function (IconType) {
    IconType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    IconType["WEB_URL"] = "WEB_URL";
    IconType["APP"] = "APP";
    IconType["PERSON_AVATAR"] = "PERSON_AVATAR";
})(IconType || (IconType = {}));
export var ActionType;
(function (ActionType) {
    ActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    ActionType["DELETE"] = "DELETE";
    ActionType["STATUS_CHANGE"] = "STATUS_CHANGE";
})(ActionType || (ActionType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var DynamicParamType;
(function (DynamicParamType) {
    DynamicParamType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    DynamicParamType["TEXT"] = "TEXT";
})(DynamicParamType || (DynamicParamType = {}));
export var InitiatorType;
(function (InitiatorType) {
    InitiatorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    InitiatorType["WIX_USER"] = "WIX_USER";
    InitiatorType["APP"] = "APP";
    InitiatorType["CONTACT"] = "CONTACT";
    InitiatorType["SITE_MEMBER"] = "SITE_MEMBER";
})(InitiatorType || (InitiatorType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["WEB_URL"] = "WEB_URL";
    Type["LIVE_SITE"] = "LIVE_SITE";
    Type["BACKOFFICE"] = "BACKOFFICE";
})(Type || (Type = {}));
export var ActionIconType;
(function (ActionIconType) {
    ActionIconType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ActionIconType["APP"] = "APP";
    ActionIconType["PERSON_AVATAR"] = "PERSON_AVATAR";
})(ActionIconType || (ActionIconType = {}));
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["HOURS"] = "HOURS";
    DurationUnit["DAYS"] = "DAYS";
    DurationUnit["MINUTES"] = "MINUTES";
})(DurationUnit || (DurationUnit = {}));
export var NotificationConfigType;
(function (NotificationConfigType) {
    NotificationConfigType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    NotificationConfigType["DEV_CENTER"] = "DEV_CENTER";
    NotificationConfigType["LEGACY_PING"] = "LEGACY_PING";
    NotificationConfigType["AUTOMATIONS"] = "AUTOMATIONS";
})(NotificationConfigType || (NotificationConfigType = {}));
//# sourceMappingURL=types.impl.js.map